"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutsideModule = void 0;
var OutsideModule;
(function (OutsideModule) {
    // Multi
    OutsideModule["JOB"] = "job";
})(OutsideModule = exports.OutsideModule || (exports.OutsideModule = {}));
